import { Box, InfoBadge } from '@medely/ui-kit';
import React, { ReactElement } from 'react';
import { MedelyDateTime } from '@medely/date-time-tools';
import { pluralize } from '../../utils/text';

type CountdownBadgeProps = {
  currentStartsTime?: string | null;
  timezone?: string | null;
};

export const CountdownBadge = ({
  currentStartsTime,
  timezone,
}: CountdownBadgeProps): ReactElement => {
  const tz = {
    tz: timezone ?? 'America/Los_Angeles',
  };
  const startTime = new MedelyDateTime(currentStartsTime as string, tz);
  const hours = MedelyDateTime.now(tz).difference(startTime, 'hours');
  const label = `Starts ${hours >= 1 ? `in ${pluralize(hours, 'hour')}` : `within the hour`}`;
  const displayBadge = hours >= 0 && hours <= 12;
  return (
    <Box testId="countdown-badge-container" alignSelf="flex-start">
      {displayBadge ? <InfoBadge color="info" label={label} /> : undefined}
    </Box>
  );
};
